import { render, staticRenderFns } from "./GerirRestaurantes.vue?vue&type=template&id=430ed477&scoped=true"
import script from "./GerirRestaurantes.vue?vue&type=script&lang=js"
export * from "./GerirRestaurantes.vue?vue&type=script&lang=js"
import style0 from "./GerirRestaurantes.vue?vue&type=style&index=0&id=430ed477&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430ed477",
  null
  
)

export default component.exports